import msg from './message/msg.json'
import validations from './validations.json'

const fr = {
    ...msg,
    validations
}

export {fr}
